import React, { useState, ReactNode } from 'react';

// Material UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';

// Icons
import { Arrow2Down, Arrow2Up } from 'icons/Arrows';

interface StateProps {
  children: ReactNode;
  title: string;
}

type Props = StateProps;

const SimpleCollapse: React.FC<Props> = ({ children, title }) => {
  const [collapse, setCollapse] = useState(true);

  return (
    <>
      <Divider variant='fullWidth' />
      <Box
        p='0.75rem 0'
        width='100%'
        display='flex'
        alignItems='center'
        justifyContent='space-between'>
        <Typography variant='h5'>{title}</Typography>
        {collapse ? (
          <IconButton onClick={() => setCollapse(false)}>
            <Arrow2Up width='0.75rem' height='0.75rem' />
          </IconButton>
        ) : (
          <IconButton onClick={() => setCollapse(true)}>
            <Arrow2Down width='0.75rem' height='0.75rem' />
          </IconButton>
        )}
      </Box>

      <Collapse in={collapse}>
        <Grid xl={6} lg={6} md={6} sm={12} xs={12}>
          {children}
        </Grid>
      </Collapse>
    </>
  );
};

export default SimpleCollapse;
export { SimpleCollapse };
